module.exports = __webpack_public_path__ + "static/media/Board's Fiduciary Duties Script Draft_1612374255025.13be3914.docx";